import React from 'react';
import CreateEventForm from './CreateEventForm';

function EditEventForm({ event, onClose, onSuccess }) {
  return <CreateEventForm event={event} onClose={onClose} onSuccess={onSuccess} compact />;
}

export default EditEventForm;
